export const useOpenWindow = () => {
  const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const openInSameTab = (url: string): void => {
    window.open(url, "_self");
  };
  return { openInNewTab, openInSameTab };
};
